import { render, staticRenderFns } from "./InventoryCard.vue?vue&type=template&id=2c5288c7&"
import script from "./InventoryCard.vue?vue&type=script&lang=js&"
export * from "./InventoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports